import { QuantifyReportDataPoint } from '@modules/quantify/store/types';

export function getQuantifyTableRowsVariants(
  tableRows: QuantifyReportDataPoint[],
) {
  const variantLabelById = tableRows.reduce(
    (map: Record<string, string>, dataPoint) => {
      if (dataPoint.variants) {
        Object.values(dataPoint.variants).forEach((variant) => {
          map[variant.id] = variant.label;
        });
      }

      return map;
    },
    {},
  );

  const variantLabels = Object.keys(variantLabelById).sort((a, b) => {
    if (typeof a === 'number' && typeof b === 'number') {
      return a - b;
    }

    if (typeof a === 'string' && typeof b === 'string') {
      return a.localeCompare(b);
    }

    return 0;
  });

  return { variantLabels, variantLabelById };
}
